import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UnstableDirective } from './directives/unstable.directive';
import { DisabledDirective } from './directives/disabled.directive';
import { TranslateModule } from '@ngx-translate/core';
import { UiModule } from '@icc/ui';
import { SortOrderIconComponent } from './sort-order-icon/sort-order-icon.component';
import { TaxRatePipe } from './services/tax-rate.pipe';
@NgModule({
  declarations: [
    UnstableDirective,
    DisabledDirective,
    SortOrderIconComponent,
    TaxRatePipe,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    UiModule,
  ],
  providers: [],
  exports: [UnstableDirective, DisabledDirective, SortOrderIconComponent, TaxRatePipe]

})
export class B2BSharedModule { }
